import { NgModule } from "@angular/core";
import { SharedModule } from "@shared/shared.module";
import { RoutesRoutingModule } from "./routes-routing.module";

import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { WelcomeComponent } from "./components/welcome/welcome.component";
import {
  DialogAddUserComponent,
  DialogEditUserComponent,
  DialogRemoveUserComponent,
  UserAdministrationComponent,
} from "@shared/components/user-administration/user-administration.component";
import { SearchComponent } from "./components/well/search/search.component";
import { WellComponent } from "./components/well/well.component";
import { AddWellComponent } from "./components/well/add/add-well.component";
import { EditWellComponent } from "./components/well/edit/edit-well.component";
import { ReportsWellComponent } from "./components/well/reports/reports-well.component";
import { AddSampleComponent } from "./components/well/samples/add/add-samples.component";
import { DeleteSampleComponent } from "./components/well/samples/delete/delete-samples.component";
import { EditSampleComponent } from "./components/well/samples/edit/edit-samples.component";
import { ReportsVoucherComponent } from "./components/vouchers/reports/reports-voucher.component";
import { SearchVouchersComponent } from "./components/vouchers/search/search-vouchers.component";
import { AddVoucherComponent } from "./components/vouchers/add/add-voucher-application.component";
import { ListSamplesComponent } from "./components/well/samples/list-samples.component";
import { ListVouchersComponent } from "./components/vouchers/edit/list-vouchers.component";
import { LabsComponent } from "./components/labs/labs.component";
import { DialogAddLabComponent } from "./components/labs/add/add-lab-dialog";
import { DialogEditLabComponent } from "./components/labs/edit/edit-lab-dialog";
import { DialogDeleteLabComponent } from "./components/labs/delete/delete-lab-dialog";
import { VoucherEditComponent } from "./components/vouchers/edit/voucher-edit";
import { VoucherLettersComponent } from "./components/vouchers/letters/voucher-letters.component";
import { BulkUploadTestResultsComponent } from "./components/bulkUploads/test-results/bulk-upload-test-results.component";
import { WildfireVoucherLetterComponent } from "./components/vouchers/letters/voucher/wildfire/wildfire-voucher-letter.component";
import { LubgwmaTestingVoucherLetterComponent } from "./components/vouchers/letters/voucher/lubgwma/lubgwma-testing-voucher-letter.component";
import { LubgwmaTreatmentVoucherLetterComponent } from "./components/vouchers/letters/voucher/lubgwma/lubgwma-treatment-voucher-letter.component";
import { ExceedenceLetterComponent } from "./components/vouchers/letters/exceedence/exceedence-letter.component";
import { AttachLetterComponent } from "./components/vouchers/letters/attach/attach-letter.component";
import { SendLetterComponent } from "./components/vouchers/letters/send/send-letter.component";
import { EditVoucherApplicationComponent } from "./components/vouchers/edit/application-edit.component";
import { UploadVoucherTestResultsComponent } from "./components/vouchers/uploads/upload-voucher-test-results";
import { ImportVoucherApplicationsComponent } from "./components/vouchers/import/import-voucher-applications";
import { NitrateExceedanceReportComponent } from "./components/vouchers/reports/lubgwma/NitrateExceedanceReport/nitrate-exceedance-report.component";
import { VoucherExceedanceNotIndicatedReportComponent } from "./components/vouchers/reports/VouchersWithExceedanceNotIndicatedReport/voucher-exceedance-not-indicated";
import { MissingLatLongComponent } from "./components/vouchers/reports/MissingLatLong/missing-lat-long.component";
import { DialogMergeWellsComponent } from "./components/well/search/merge-wells-dialog-component";
import { DialogEditVoucherComponent } from "./components/vouchers/edit/voucher-edit-dialog";
import { DialogEditApplicationComponent } from "./components/vouchers/edit/application-edit-dialog";
import { DialogMergeVouchersComponent } from "./components/vouchers/search/merge-vouchers-dialog-component";
import { SearchHouseholdsComponent } from "./components/households/search/search-households.component";
import { HouseholdEditComponent } from "./components/households/edit/household-edit";
import { AddHouseholdComponent } from "./components/households/add/add-household.component";
import { HouseholdAssociationsComponent } from "./components/households/associations/household-associations.component";
import { DialogAssociateWellToHouseholdComponent } from "./components/households/associations/associate/associate-household-well-dialog";
import { DialogEditHouseholdComponent } from "./components/households/edit/household-edit-dialog";
import { HouseholdiIteractionsComponent } from "./components/households/interactions/household-interactions.component";
import { DialogEditHouseholdInteractionComponent } from "./components/households/interactions/household-interection-edit-dialog";
import { DialogMergeHouseholdsComponent } from "./components/households/search/merge-households-dialog-component";
import { DialogEditHousingUnitComponent } from "./components/households/edit/units/housingunit-edit-dialog";
import { HousingUnitEditComponent } from "./components/households/edit/units/housingunit-edit";
import { AddHousingUnitComponent } from "./components/households/add/units/add-housingunit.component";
import { HousingUnitAssociationsComponent } from "./components/households/associations/housingunit-associations.component";
import { DialogAssociateHousingUnitToHouseholdComponent } from "./components/households/associations/associate/associate-housingunit-household-dialog";
import { DialogAssociateHouseholdToHousingUnitComponent } from "./components/households/associations/associate/associate-household-housingunit-dialog";
import { DialogAssociateHousingUnitToWellComponent } from "./components/households/associations/associate/associate-housingunit-well-dialog";
import { DialogAddTreatmentComponent } from "./components/households/treatments/add/add-treatment-dialog";
import { DialogDeleteTreatmentComponent } from "./components/households/treatments/delete/delete-treatment-dialog";
import { DialogEditHousingUnitAssociationComponent } from "./components/households/edit/units/housingunit-association-edit-dialog";
import { NotEligibleVoucherLetterComponent } from "./components/vouchers/letters/voucher/not-eligible/not-eligible-voucher-letter.component";
import { HouseholdLettersComponent } from "./components/households/letters/household-letters.component";
import { HousingUnitTreatmentsComponent } from "./components/households/treatments/housingunit-treatments.component";
import { HouseholdExceedenceLetterComponent } from "./components/households/letters/nitrate-exceedance/household-exceedence-letter.component";
import { AttachHouseholdLetterComponent } from "./components/households/letters/attach-household-letter.component";
import { SearchInvoicesComponent } from "./components/invoices/search/search-invoices.component";
import { InvoiceEditComponent } from "./components/invoices/edit/invoice-edit";
import { AddInvoiceComponent } from "./components/invoices/add/add-invoice.component";
import { WaterSystemsComponent } from "./components/water-systems/water-systems.component";
import { DialogEditHousingUnitWaterSystemComponent } from "./components/water-systems/water-system-edit-dialog";
import { RetestsSearchComponent } from "./components/retests/search/retests-search.component";
import { DialogEditRetestsComponent } from "./components/retests/edit/retests-edit-dialog";
import { COCHouseholdLetterComponent } from "./components/households/letters/chain-of-custody/coc-household-letter.component";
import { COCVoucherLetterComponent } from "./components/vouchers/letters/voucher/chain-of-custody/coc-voucher-letter.component";
import { ListRetestsComponent } from "./components/retests/list-retests.component";
import { ChainOfCustodyComponent } from "./components/retests/chain-of-custody/chain-of-custody.component";
import { DialogAddRetestsComponent } from "./components/retests/retests-add-dialog";
import { ChainOfCustodyLetterComponent } from "./components/retests/chain-of-custody/letter/chain-of-custody-letter.component";
import { HouseholdMissingLatLongComponent } from "./components/households/reports/MissingLatLong/household-missing-lat-long.component";
import { HouseholdMultipleHousingUnitsComponent } from "./components/households/reports/MultipleHousingUnits/household-multiple-housing-units.component";
import { HouseholdInteractionsApprovalNeededReportComponent } from "./components/households/interactions/householdInteractionsApprovalNeededReport/household-Interactions-approval-needed";
import {
  DialogEditPartnerComponent,
  DialogRemovePartnerComponent,
  PartnerAdministrationComponent,
  DialogPartnerInfoComponent,
} from "./components/admin/partners/partner-administration.component";
import { PartnerAccessComponent } from "./components/partners/partner-access.component";
import { PartnersLubgwmaPlumbersComponent } from "./components/partners/lubgwma-plumbers/lubgwma-plumbers.component";
import { DialogLinkTreatmentComponent } from "./components/well/samples/link/link-treatment-dialog";
import { DialogBulkOperationRetestsComponent } from "./components/retests/search/bulk-operation/retests-bulk-dialog";

const COMPONENTS = [
  DialogBulkOperationRetestsComponent,
  PartnersLubgwmaPlumbersComponent,
  PartnerAccessComponent,
  DashboardComponent,
  UserAdministrationComponent,
  DialogAddUserComponent,
  DialogEditUserComponent,
  DialogRemoveUserComponent,
  PartnerAdministrationComponent,
  DialogEditPartnerComponent,
  DialogPartnerInfoComponent,
  DialogRemovePartnerComponent,
  WelcomeComponent,
  SearchComponent,
  WellComponent,
  AddWellComponent,
  EditWellComponent,
  ReportsWellComponent,
  AddSampleComponent,
  DeleteSampleComponent,
  EditSampleComponent,
  ReportsVoucherComponent,
  SearchVouchersComponent,
  AddVoucherComponent,
  ListSamplesComponent,
  ListRetestsComponent,
  ListVouchersComponent,
  LabsComponent,
  DialogAddLabComponent,
  DialogEditLabComponent,
  DialogDeleteLabComponent,
  VoucherLettersComponent,
  VoucherEditComponent,
  BulkUploadTestResultsComponent,
  WildfireVoucherLetterComponent,
  LubgwmaTestingVoucherLetterComponent,
  LubgwmaTreatmentVoucherLetterComponent,
  NotEligibleVoucherLetterComponent,
  ExceedenceLetterComponent,
  HouseholdExceedenceLetterComponent,
  AttachLetterComponent,
  AttachHouseholdLetterComponent,
  SendLetterComponent,
  EditVoucherApplicationComponent,
  UploadVoucherTestResultsComponent,
  ImportVoucherApplicationsComponent,
  NitrateExceedanceReportComponent,
  VoucherExceedanceNotIndicatedReportComponent,
  MissingLatLongComponent,
  HouseholdMissingLatLongComponent,
  VoucherEditComponent,
  SearchHouseholdsComponent,
  SearchInvoicesComponent,
  HouseholdEditComponent,
  AddHouseholdComponent,
  HouseholdAssociationsComponent,
  DialogAssociateWellToHouseholdComponent,
  HouseholdiIteractionsComponent,
  DialogEditHouseholdInteractionComponent,
  HouseholdLettersComponent,
  DialogAddTreatmentComponent,
  DialogLinkTreatmentComponent,
  DialogDeleteTreatmentComponent,
  HousingUnitTreatmentsComponent,
  DialogMergeHouseholdsComponent,
  HousingUnitEditComponent,
  AddHousingUnitComponent,
  HousingUnitAssociationsComponent,
  DialogAssociateHousingUnitToHouseholdComponent,
  DialogAssociateHouseholdToHousingUnitComponent,
  DialogAssociateHousingUnitToWellComponent,
  DialogEditHousingUnitAssociationComponent,
  InvoiceEditComponent,
  AddInvoiceComponent,
  WaterSystemsComponent,
  RetestsSearchComponent,
  DialogEditRetestsComponent,
  DialogAddRetestsComponent,
  COCHouseholdLetterComponent,
  COCVoucherLetterComponent,
  ChainOfCustodyComponent,
  ChainOfCustodyLetterComponent,
  HouseholdInteractionsApprovalNeededReportComponent,
  HouseholdMultipleHousingUnitsComponent,
];

const COMPONENTS_DYNAMIC = [
  DialogMergeWellsComponent,
  DialogEditVoucherComponent,
  DialogDeleteLabComponent,
  DialogEditApplicationComponent,
  DialogMergeVouchersComponent,
  DialogAssociateWellToHouseholdComponent,
  DialogEditHouseholdComponent,
  DialogEditHouseholdInteractionComponent,
  DialogMergeHouseholdsComponent,
  DialogEditHousingUnitComponent,
  DialogAssociateHousingUnitToHouseholdComponent,
  DialogAssociateHouseholdToHousingUnitComponent,
  DialogAssociateHousingUnitToWellComponent,
  DialogAddTreatmentComponent,
  DialogDeleteTreatmentComponent,
  DialogEditHousingUnitAssociationComponent,
  DialogEditHousingUnitWaterSystemComponent,
  DialogEditRetestsComponent,
  DialogAddRetestsComponent,
];

@NgModule({
  imports: [SharedModule, RoutesRoutingModule],
  declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC],
})
export class RoutesModule {}
